export default "__VITE_ASSET__ZUuQ9LRN__"